import {
  AccessorFnColumnDef,
  CellContext,
  HeaderContext
} from "@tanstack/react-table";
import { ReactNode } from "react";

export type TableCellProps<T, TVal> =
  Omit<CellContext<T, TVal>, "cell">
  & Omit<AccessorFnColumnDef<T, TVal>, "cell" | "header" | "id">
  & {
  id: string;
  header?: string;
  align?: "left" | "center" | "right";
  overflow?: "ellipsis" | "clip";
  render?: (info: CellContext<T, TVal>) => unknown;
  headerRender?: (info: HeaderContext<T, TVal>) => ReactNode;
};

export const TableCell = <T, TVal>({
  getValue,
}: TableCellProps<T, TVal>) => {
  return (
    <>
      {getValue<TVal>()}
    </>
  );
};
